export default {

    validateEmail(email)
    {
        var RegExp =  /\S+@\S+\.\S+/;
        return (RegExp.test(email));
    },

    handleCountryCode(input,code)
    {
        return (input.indexOf(code)===-1 ? code + input : input);
    },

    validatePhoneNumber(input)
    {
        var RegExp = /^\+(?:[0-9] ?){5,10}[0-9]$/;
        return (RegExp.test(input));
    },

    validateName(input)
    {

        if(input!==null && input!==undefined && input.value!=='' && input.value!==undefined && input.value.length > 1)
        {
            var RegExp = /^[a-zA-Z ]{2,30}$/;
            return (RegExp.test(input.value) ? 'success' : 'error');
        }
    },

    validateNumber(input){

        if(input!==null && input!==undefined && input.value!=='' && input.value!==undefined && input.value.length > 1)
        {
            var RegExp = /^\d{4,5}$/;
            return (RegExp.test(input.value) ? 'success' : 'error');
        }
    },

    validateStatePhoneNumber(input)
    {
        if(input!==null && input!==undefined && input.value!=='' && input.value!==undefined && input.value.length > 3) {

            var RegExp = /^\+(?:[0-9]?){5,10}[0-9]$/;
            return (RegExp.test(input.value) ? 'success' : 'error');
        }
    },

}


// WEBPACK FOOTER //
// ./src/utils/validation.js